import PrimaryButton from "../../../Components/Buttons/primary-button";

import { modalVariants } from "../../../Utils/constants";

export default function renderAverageMonthlyBalance(modalContext) {
  const { updateModalComponent, setModalVariant, setModalTitle, onModalClose } = modalContext;

  updateModalComponent(() => (
    <>
      <div className="modal-dialog-content">
        <span className="modal-content-text mb-0">
          This is your average daily balance for the month, calculated by adding each day’s ending balance and dividing
          by the number of days so far.
        </span>
      </div>
      <div className="action-container">
        <PrimaryButton onClick={onModalClose}>Got It</PrimaryButton>
      </div>
    </>
  ));
  setModalVariant(modalVariants.tooltipDialog);
  setModalTitle("Average monthly balance");
}
